module.exports = __webpack_public_path__ + "media/images/official/special_double_life_worry_cost-6a55302a7af9d310e4119f7e0f768f1e.png";